// extracted by mini-css-extract-plugin
export default {"base":"NotFound__base___ejqni","description":"NotFound__description___pFwqN"};